/**
 * @flow
 * @relayHash c2877ab49fd37fd14cabb5e3cc4cd399
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InfoStringEditInput = {
  id: string,
  title: string,
  infostring?: ?boolean,
  infostring_hot?: ?boolean,
  order: number,
  clientMutationId?: ?string,
};
export type InfoStringEditMutationVariables = {|
  input: InfoStringEditInput
|};
export type InfoStringEditMutationResponse = {|
  +InfoStringEdit: ?{|
    +error: ?string,
    +infoStringEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
  |}
|};
export type InfoStringEditMutation = {|
  variables: InfoStringEditMutationVariables,
  response: InfoStringEditMutationResponse,
|};
*/


/*
mutation InfoStringEditMutation(
  $input: InfoStringEditInput!
) {
  InfoStringEdit(input: $input) {
    error
    infoStringEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "InfoStringEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "InfoStringEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "InfoStringEditInput!"
      }
    ],
    "concreteType": "InfoStringEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "infoStringEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "InfoStringEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "InfoString",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "InfoStringEditMutation",
  "id": null,
  "text": "mutation InfoStringEditMutation(\n  $input: InfoStringEditInput!\n) {\n  InfoStringEdit(input: $input) {\n    error\n    infoStringEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "InfoStringEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "InfoStringEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'de9d994d0f441cf3706c45859ca8591c';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/InfoStringEditMutation.graphql.js